const validate = (values) => {
  const errors = {};

  if (!values.financial_report_id) {
    errors.financial_report_id = 'Financial Report field shouldn’t be empty';
  }

  if (!values.user_owner_id) {
    errors.user_owner_id = 'User Owner field shouldn’t be empty';
  }

  if (!values.title) {
    errors.title = 'Title field shouldn’t be empty';
  }

  if (!values.amount) {
    errors.amount = 'Amount field shouldn’t be empty';
  }

  return errors;
};

export default validate;